
export const Corner = {
  0: "not a corner",
  1: "first corner",
  2: "second corner",
  3: "third corner",
  4: "fourth corner"
};

export const CornerRandom = {
  1: "first corner",
  2: "second corner",
  3: "third corner",
  4: "fourth corner"
};

export const DistanceType = {
  1: "sprint",
  2: "mile",
  3: "medium",
  4: "long"
};

export const Grade = {
  100: "G1",
  200: "G2",
  300: "G3",
  400: "OP",
  700: "Pre-OP",
  800: "maiden",
  900: "debut",
  999: "daily"
};

export const GroundCondition = {
  1: "good",
  2: "slightly heavy",
  3: "heavy",
  4: "bad"
};

export const GroundType = {
  1: "turf",
  2: "dirt"
};

export const IsBasisDistance = {
  0: "non-core",
  1: "core"
};

export const IsDirtGrade = {
  0: "False",
  1: "True"
};

export const IsMoveLane = {
  1: "moved closer to the fence",
  2: "moved further from the fence"
};

// inner <= 0.2 < middle <= 0.4 outer <= 0.6 < outside
export const LaneType = {
  Inner: 0.2,
  Middle: 0.4,
  Outer: 0.6,
  Outside: 1.0 // Implicit > 0.6
};

export const Lastspurt = {
  0: "not enough stamina to even finish at base speed",
  1: "enough stamina to run above base speed, but not enough to finish at max speed",
  2: "enough stamina to finish at max speed"
};

export const Motivation = {
  1: "Terrible", // 絶不調
  2: "Bad", // 不調
  3: "Normal", // 普通
  4: "Good", // 好調
  5: "Perfect" // 絶好調
};

export const Phase = {
  0: "Early-Race",
  1: "Mid-Race",
  2: "Late-Race",
  3: "Last Spurt"
};

export const PhaseCornerRandom = {
  0: "Early-Race",
  1: "Mid-Race",
  2: "Late-Race",
  3: "Last Spurt"
};

export const PhaseFirstQuarterRandom = {
  0: "Early-Race",
  1: "Mid-Race",
  2: "Late-Race",
  3: "Last Spurt"
};

export const PhaseLaterHalfRandom = {
  0: "Early-Race",
  1: "Mid-Race",
  2: "Late-Race",
  3: "Last Spurt"
};

export const PhaseRandom = {
  0: "Early-Race",
  1: "Mid-Race",
  2: "Late-Race",
  3: "Last Spurt"
};

export const Rotation = {
  1: "clockwise/right",
  2: "counterclockwise/left"
};

export const RunningStyle = {
  1: "Front Runner",
  2: "Pace Chaser",
  3: "Late Surger",
  4: "End Closer"
};

export const Season = {
  1: "spring",
  2: "summer",
  3: "fall",
  4: "winter",
  5: "cherry blossom"
};

export const Slope = {
  0: "no slope",
  1: "up",
  2: "down"
};

export const StraightFrontType = {
  1: "straight in front of the audience",
  2: "straight on the opposite side from the audience"
};

export const Time = {
  0: "Any",
  1: "Morning",
  2: "Daytime",
  3: "Evening",
  4: "Night"
};

export const TrackId = {
  10001: "Sapporo", // 札幌
  10002: "Hakodate", // 函館
  10003: "Niigata", // 新潟
  10004: "Fukushima", // 福島
  10005: "Nakayama", // 中山
  10006: "Tokyo", // 東京
  10007: "Chukyo", // 中京
  10008: "Kyoto", // 京都
  10009: "Hanshin", // 阪神
  10010: "Kokura", // 小倉
  10101: "Ooi", // 大井
  10103: "Kawasaki", // 川崎
  10104: "Funabashi", // 船橋
  10105: "Morioka", // 盛岡
};

export const Weather = {
  1: "sunny",
  2: "cloudy",
  3: "rainy",
  4: "snowy"
};
